import React, { useRef } from "react";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';

import css from './SupplierCardCarousel.module.scss';
import { VwpPackage } from "../types";
import SupplierCard from "../SupplierCard";
import { CelebrantIcon } from "@assets/icons";
import { MAX_CONTENT_WIDTH, SLIDER_GAP } from "@helper/constants";
import { useSliderControls } from "@components/Slider/helpers";
import LegacySlider from "@components/Slider/LegacySlider";

type SupplierCardCarouselProps = {
    icon?: string,
    category: string,
    suppliers: VwpPackage[],
    onClick: (supplierId: number) => void,
}

function SupplierCardCarousel({ icon, category, suppliers, onClick }: SupplierCardCarouselProps){
    const ref = React.useRef<HTMLDivElement>(null);
    const imageStyle = { width: '1.875rem', height: '1.875rem' };

    const sliderRef = useRef<HTMLDivElement>(null);
    const {
        isSlidesOverflown,
        slideIndex,
        isPreviousEnabled,
        setSlideIndex,
        isNextEnabled,
        handlePrev,
        handleNext,
    } = useSliderControls(sliderRef, suppliers.length, MAX_CONTENT_WIDTH);

    return (<div style={{ maxWidth: `${MAX_CONTENT_WIDTH}px` }} ref={ref}>
        <div className={css.title}>
            <div className={css.icon}>
                { icon
                    ? <img src={icon} alt={category} className={css.svgIcon} style={imageStyle} />
                    : <CelebrantIcon style={imageStyle} />
                }
            </div>
            <h2>{category} ({suppliers.length})</h2>
            {isSlidesOverflown ? <>
                <button className={css.swipeButton + ' d-none d-md-flex'} disabled={!isPreviousEnabled} onClick={handlePrev}>
                    <Icon icon={faChevronLeft} />
                </button>
                <button onClick={handleNext} disabled={!isNextEnabled} className={css.swipeButton + ' d-none d-md-flex'}>
                    <Icon icon={faChevronRight} />
                </button>
            </> : null}
        </div>
        <LegacySlider className={css.slider} idx={slideIndex} handleIndex={setSlideIndex} gap={SLIDER_GAP} ref={sliderRef}>
            {suppliers.map((s) =>
                (<SupplierCard
                    key={s.Id}
                    onClick={onClick}
                    supplier={{
                        image: s.SupplierListingImage,
                        ...s,
                    }}
                />)
            )}
        </LegacySlider>
        </div>);
}

export default SupplierCardCarousel;
